import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Selector from '../../components/forms/Selector';
import ClassificationSelect from './ClassificationSelect';
import language from '../../variables/language';
import * as api from './api';
import { LEVELS_BY_KEY } from './courseLevels';
import '../../css/modals.css';

const courseLevel = LEVELS_BY_KEY.course;

// Name + level + classification up front; description and everything else
// stays editable right away on the course workspace page (see
// CourseEditForm.jsx), same "don't front-load every field" call the
// exercise-templates create modal already made.
export default function CourseCreateModal({ isOpen, onClose, onCreated }) {
   const navigate = useNavigate();
   const [name, setName] = useState('');
   const [level, setLevel] = useState('');
   const [classification, setClassification] = useState('');
   const [saving, setSaving] = useState(false);

   if(!isOpen) return '';

   const stopProp = e => e.stopPropagation();

   const handleClose = () => {
      setName('');
      setLevel('');
      setClassification('');
      onClose();
   };

   const handleSubmit = (e) => {
      e.preventDefault();
      if(saving || !name.trim()) return;
      setSaving(true);
      const payload = { name: name.trim() };
      if(level) payload.level = level;
      if(classification) payload.classification = classification;
      api.createOne(courseLevel.apiBase, payload).then((response) => {
         setName('');
         setLevel('');
         setClassification('');
         onCreated(response.data);
      }).catch(err => {
         if(err.response && err.response.status === 401) navigate('/login');
         console.log(err);
      }).finally(() => setSaving(false));
   };

   return (
      <div className='modal-update' onClick={handleClose} style={{ display: 'flex' }}>
         <div className='modal-window course-create-modal' onClick={stopProp}>
            <h3 className='modal-w-title'>Новий курс</h3>
            <form onSubmit={handleSubmit}>
               <div className='flex-from-input-wraper course-create-field-full' data-label={language[language.lang].name}>
                  <input className='submit-field from-input txt-c' type='text' autoFocus
                     placeholder={language[language.lang].name}
                     value={name} onChange={(e) => setName(e.target.value)} />
               </div>
               <div className='course-create-fields-row'>
                  <div className='flex-from-input-wraper course-create-field' data-label={language[language.lang].level}>
                     <Selector className='submit-field form-selection txt-c'
                        name='level' url='/api/levels' value={level}
                        selectorsHundler={(value) => setLevel(value)} />
                  </div>
                  <div className='flex-from-input-wraper course-create-field' data-label={language[language.lang].clasification}>
                     <ClassificationSelect className='submit-field form-selection txt-c'
                        value={classification} onChange={setClassification} />
                  </div>
               </div>
               <button type='submit' className='form-button txt-c' disabled={saving || !name.trim()} style={{ marginTop: 14 }}>
                  {saving ? language[language.lang]['Loading ...'] : language[language.lang].save}
               </button>
            </form>
         </div>
      </div>
   );
}
